
import React from 'react';
import { Outlet } from 'react-router-dom';
import { DoctorSidebar } from './sidebar';
import { DoctorPermissionsProvider } from '@/contexts/DoctorPermissionsContext';
import DoctorHeader from '@/ui/shared-components/doctor/Header';
import DoctorFooterNav from '@/ui/shared-components/doctor/BottomNav';
import { SidebarProvider } from '@/components/ui/sidebar';
import { useMediaQuery } from '@/hooks/use-media-query';

const DoctorLayout = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  return (
    <DoctorPermissionsProvider>
      <SidebarProvider defaultOpen={isDesktop}>
        <div className="flex min-h-screen bg-background">
          {/* Only render sidebar on desktop */}
          <DoctorSidebar />
          
          <div className="flex-1 w-full">
            <DoctorHeader />
            <div className="container mx-auto p-4 pb-24 pt-20 md:pl-6">
              <Outlet />
            </div>
            {/* Only show footer nav on mobile */}
            {!isDesktop && <DoctorFooterNav />}
          </div>
        </div>
      </SidebarProvider>
    </DoctorPermissionsProvider>
  );
};

export default DoctorLayout;
